import { Layout as LayoutComponent, useLayoutContext } from './layout';
import { LayoutHeader } from './layoutHeader';
import { LayoutSider } from './layoutSider';
import { LayoutContent } from './layoutContent';
import { LayoutFooter } from './layoutFooter';
import { LayoutBreadCrumb } from './layoutBreadCrumb';
import { LayoutLogo } from './layout-logo';
var Layout = LayoutComponent;
Layout.Logo = LayoutLogo;
Layout.Header = LayoutHeader;
Layout.Sider = LayoutSider;
Layout.Content = LayoutContent;
Layout.Footer = LayoutFooter;
Layout.BreadCrumb = LayoutBreadCrumb;
export { Layout, useLayoutContext };